export default "__VITE_ASSET__9c8df95f__"